import { Mail } from "lucide-react";
import { LOGO_URL } from "@/data/content";
import { Reveal, GoldLine, SectionHeading } from "@/components/Reveal";

export default function Press() {
  return (
    <main data-testid="press-page" className="bg-[#080808] min-h-screen pt-40 pb-24">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <SectionHeading eyebrow="Press" title="Ufficio" goldWord="Stampa." />
        <Reveal delay={0.2}>
          <p className="mt-10 text-lg font-light text-[#A5A5A5] leading-relaxed">
            Per richieste stampa, interviste, comunicati e materiali editoriali
            su Billions Group e le sue business unit, il nostro ufficio stampa
            è a disposizione di giornalisti e media.
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="mt-14 bg-[#141414] border border-[#C6A45D]/25 p-10 sm:p-14 text-center">
            <img src={LOGO_URL} alt="Billions Group" className="h-14 w-auto mx-auto mb-8" />
            <p className="eyebrow mb-4 !text-[10px]">Contatto stampa</p>
            <p className="font-display text-2xl sm:text-3xl font-light text-[#F5F2EB]">
              Sara Esposito
            </p>
            <p className="text-sm text-[#A5A5A5] mt-2 font-light">
              Ufficio Stampa Billions Group
            </p>
            <GoldLine className="my-8 w-20 mx-auto" />
            <a
              href="mailto:saraesposito@billionsgroup.eu"
              data-testid="press-email-link"
              className="group inline-flex items-center gap-3 px-10 py-4 bg-[#C6A45D] text-[#080808] text-xs tracking-[0.25em] uppercase font-semibold hover:bg-[#E5C776] transition-colors duration-300"
            >
              <Mail size={15} />
              saraesposito@billionsgroup.eu
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.4}>
          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-8 text-sm font-light">
            <div className="border border-[#C6A45D]/15 p-8">
              <p className="eyebrow mb-4 !text-[10px]">Il Gruppo</p>
              <p className="text-[#A5A5A5] leading-relaxed">
                Billions Group è una realtà imprenditoriale con sei business
                unit — Food, Luxury, Hospitality, Real Estate, Beauty e New
                Venture — unite da un'unica visione: strategia, sviluppo,
                partnership e creazione di valore.
              </p>
            </div>
            <div className="border border-[#C6A45D]/15 p-8">
              <p className="eyebrow mb-4 !text-[10px]">Riferimenti societari</p>
              <p className="text-[#A5A5A5] leading-relaxed">
                BILLIONS GROUP LTD
                <br />
                Viale Tsar Boris III n° 85, Sofia
                <br />
                P.I. 208789980
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </main>
  );
}
